import React, { useState } from "react";
import { useForm } from "react-hook-form";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

function ConsultationPage() {
  const [enquiryStatus, setEnquiryStatus] = useState(null);
  const [progress, setProgress] = useState(0);

  const inquiryTypes = [
    { value: "virtual_consult", label: "Virtual Consult" },
    { value: "on_site", label: "On-Site" },
    { value: "home_vastu", label: "Home Vastu" },
    { value: "office_vastu", label: "Office Vastu" },
    { value: "online_session", label: "Online Session" },
    { value: "in_person_visit", label: "In-Person Visit" },
  ];

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      contact_person: "",
      email: "",
      message: "",
      company_name: "",
      phone: "",
      inquiry_type: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      const response = await fetch(`${API_BASE_URL}/account/inquiries/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setEnquiryStatus("success");
        startSuccessAnimation();
        reset(); // Reset form fields after successful submission
      } else {
        setEnquiryStatus("error");
      }
    } catch (error) {
      setEnquiryStatus("error");
    }
  };

  const startSuccessAnimation = () => {
    setProgress(0);
    let currentProgress = 0;
    const interval = setInterval(() => {
      currentProgress += 2;
      setProgress(currentProgress);
      if (currentProgress >= 100) {
        clearInterval(interval);
        setTimeout(() => setEnquiryStatus(null), 500);
      }
    }, 50);

    setTimeout(() => setEnquiryStatus(null), 5000);
  };

  return (
    <section className="footer-cta">
      <div style={{ display: "grid", placeItems: "center" }}>
        <h2>Free Consultation & Transform Your Space Today</h2>
        <p style={{ color: "black" }}>
          Contact us to explore our personalized Vastu solutions and start your
          journey towards harmony and positivity.
        </p>
      </div>
      <div className="enquiry-form-inline">
        <h2>Consultation Form</h2>
        <form onSubmit={handleSubmit(onSubmit)} className="row g-4">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control input-underline"
              placeholder="Contact Person"
              {...register("contact_person", {
                required: "Contact Person is required",
                minLength: {
                  value: 2,
                  message: "Contact Person must be at least 2 characters",
                },
              })}
            />
            {errors.contact_person && (
              <p className="error-message">{errors.contact_person.message}</p>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="email"
              className="form-control input-underline"
              placeholder="Email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address",
                },
              })}
            />
            {errors.email && (
              <p className="error-message">{errors.email.message}</p>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="text"
              className="form-control input-underline"
              placeholder="Company Name"
              {...register("company_name",{
                required: "Company name is required",
                minLength: {
                  value: 2,
                  message: "Company name must be at least 2 characters",
                },
              })}
            />
            {errors.company_name && (
              <p className="error-message">{errors.company_name.message}</p>
            )}
          </div>
          <div className="col-md-6">
            <input
              type="tel"
              className="form-control input-underline"
              placeholder="Phone"
              {...register("phone", {
                required: "Phone number is required",
                pattern: {
                  value: /^\+?[1-9]\d{1,14}$/,
                  message: "Please enter a valid phone number",
                },
              })}
            />
            {errors.phone && (
              <p className="error-message">{errors.phone.message}</p>
            )}
          </div>
          <div className="col-12">
            <textarea
              className="form-control input-underline"
              placeholder="Message"
              {...register("message", {
                required: "Message is required",
                minLength: {
                  value: 10,
                  message: "Message must be at least 10 characters",
                },
              })}
            />
            {errors.message && (
              <p className="error-message">{errors.message.message}</p>
            )}
          </div>
          <div className="col-12">
            <select
              className="form-select input-underline"
              {...register("inquiry_type", {
                required: "Please select a consultation type",
              })}
            >
              <option value="">Select Consultation Type</option>
              {inquiryTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
            {errors.inquiry_type && (
              <p className="error-message">{errors.inquiry_type.message}</p>
            )}
          </div>
          <div className="col-12">
            <button type="submit" className="btn">
              Submit Enquiry
            </button>
          </div>
        </form>
      </div>
      {enquiryStatus && (
        <div className={`enquiry-status ${enquiryStatus}`}>
          {enquiryStatus === "success"
            ? "Enquiry sent successfully!"
            : "Error sending enquiry. Please try again later."}
          {enquiryStatus === "success" && (
            <div className="progress-bar">
              <div
                className="progress-bar-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

export default ConsultationPage;